import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IconBasedContentBox } from "../icon-based-content-box/icon-based-content-box";
import { FontAwesomeDuoToneStyle } from "../../fontawesome";
import { Box, makeStyles } from "@material-ui/core";
import { TextUtils } from '../../utils/text-utils';

const useStyles = makeStyles(theme => ({
    actionLink: {
        color: theme.palette.primary.main
    }
}));

export const Email = ({ value }) => {
    const classes = useStyles();

    return !TextUtils.isNullOrWhiteSpace(value) ? 
        <Box>
            {
                value.split(';')
                    .map((mailAddress, index) => (
                        <IconBasedContentBox key={`mail-${index}`} 
                            icon={<FontAwesomeIcon icon={["fad", "at"]} size="lg" style={FontAwesomeDuoToneStyle} />}>
                            <a href={`mailto:${mailAddress}`} className={classes.actionLink}>{mailAddress}</a>
                        </IconBasedContentBox>
                    ))
            }
        </Box> : 
        null;
}